import React, { useState, useEffect } from "react";
import UploadImagePopup from "../../default/popup/uploadImagePopup";
import { useSelector, useDispatch } from "react-redux";
import { createImage } from '../../default/popup/imageCropper/imageCropCanvas/canvasUtil';
import Breadcrumb from "../../default/breadcrumb/breadcrumb";
import SidebarMenu from "../menu/sidebarMenu";
import Header from "../../../components/default/header";
import { Helmet } from "react-helmet";

const UserSummery = () => {
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.auth);
    const { user } = userInfo;

    const [formData, setFormData] = useState({
        profileLink: ''
    });

    const [openPopup, setPopup] = useState(false);

    useEffect(() => {
        if (user) {
            setFormData({
                profileLink: user.profilePhoto || ''
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // dispatch(updateUser(formData));
    };

    const handleOpenModal = () => {
        setPopup(true);
    };

    return (
        <>
            <div className="menu-with-settings sidebar-menu-enable">
                <Helmet><title>Manage</title></Helmet>
                <Header />
                <div className="sidebar-with-content ds-flex">
                    <SidebarMenu />
                    <div className="content-right">
                        <Breadcrumb />
                        <div class="connection-header common-header">
                            <h3>Update profile</h3>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="settings-list-wrapper">
                                <div className="single-settings">
                                    <h5 className="setting-title">Personal Information</h5>
                                    <div className="setting-content">
                                        <div className="sng-content-repeater business-profile">
                                            <div className="sng-content">
                                                <h5>Profile photo</h5>
                                                <label htmlFor="ProfilePhoto" onClick={handleOpenModal}>
                                                    <img src={formData.profileLink} alt={formData.firstName} />
                                                    <i className="ri-edit-2-line"></i>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* popup area */}
                            <UploadImagePopup openModal={openPopup} setOpen={setPopup} />
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserSummery;
